/**
 * Cotton World mega menu v3: keep header --submenu-height in sync.
 * Column hover panels removed — layout is static (Figma).
 */
(function () {
  'use strict';

  function updateMegaMenuSubmenuMetrics(submenu) {
    if (!(submenu instanceof HTMLElement) || !submenu.hasAttribute('data-active')) return;

    const headerComponent = submenu.closest('header-component');
    if (!(headerComponent instanceof HTMLElement)) return;

    const submenuHeight = submenu.offsetHeight;
    const isOverlapSituation = headerComponent.hasAttribute('data-submenu-overlap-bottom-row');
    const headerVisibleHeight =
      isOverlapSituation && headerComponent.offsetHeight > 0
        ? headerComponent.querySelector('.header__row--top')?.offsetHeight ?? 0
        : headerComponent.offsetHeight;

    headerComponent.style.setProperty('--submenu-height', `${submenuHeight}px`);
    const fullOpenHeaderHeight = submenuHeight === 0 ? 0 : submenuHeight + headerVisibleHeight;
    headerComponent.style.setProperty('--full-open-header-height', `${fullOpenHeaderHeight}px`);
  }

  let frame = 0;
  function scheduleSync() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      document.querySelectorAll('.menu-list__submenu[data-active]:has(.cw-mega-menu)').forEach((el) => {
        updateMegaMenuSubmenuMetrics(el);
      });
    });
  }

  function observeMegaSubmenus(root) {
    root.querySelectorAll('.menu-list__submenu:has(.cw-mega-menu)').forEach((submenu) => {
      if (!(submenu instanceof HTMLElement)) return;
      if (submenu.dataset.cwMegaResizeObserved === 'true') return;
      submenu.dataset.cwMegaResizeObserved = 'true';
      new ResizeObserver(scheduleSync).observe(submenu);

      if (submenu.dataset.cwMegaActivationObserved === 'true') return;
      submenu.dataset.cwMegaActivationObserved = 'true';
      new MutationObserver((mutations) => {
        const opened = mutations.some(
          (m) => m.type === 'attributes' && m.attributeName === 'data-active' && submenu.hasAttribute('data-active')
        );
        if (opened) scheduleSync();
      }).observe(submenu, { attributes: true, attributeFilter: ['data-active'] });
    });
  }

  function init() {
    observeMegaSubmenus(document);
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', scheduleSync, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (container instanceof HTMLElement) observeMegaSubmenus(container);
    scheduleSync();
  });
})();
